module.exports = __webpack_public_path__ + "img/tv-retro.47ba0d97.svg";